import React, { useState, useEffect, useContext, Component,useRef, useCallback } from 'react';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import Header from '../../components/Header'; // Replace this with your Header component
import Footer from '../../components/Footer';
import { Link, useNavigate, useParams,useLocation } from 'react-router-dom';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance';
import { Helmet } from 'react-helmet';
import Select from 'react-select'; // Import react-select
import toast from 'react-hot-toast';
import GooglePlaceSelect from '../../components/extra/GooglePlaceSelect';
 
const AllVendors = () => {

  const { Headers, isHeader } = useBlogContext();
  const formatContactNumber = (number) => {
    const digits = String(number || "").replace(/\D/g, "");
    return digits.length === 10 ? `91${digits}` : digits;
  };
  const callNumber = formatContactNumber(Headers?.phone);
  const whatsappNumber = formatContactNumber(Headers?.whatsapp || Headers?.phone);
  const callHref = callNumber ? `tel:+${callNumber}` : "#";
  const whatsappHref = whatsappNumber ? `https://api.whatsapp.com/send/?phone=%2B${whatsappNumber}` : "#";

const [showPopup, setShowPopup] = useState(false);
  const [formData, setFormData] = useState({
  name: '',
  email: '',
  phone: '',
  message: ''
});

const handleFormChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
};

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await axiosInstance.post('/contact-enquire', formData);
    toast.success('Enquiry sent successfully');
    setFormData({ name: '', email: '', phone: '', message: '' });
    setShowPopup(false);
  } catch (error) {
    console.error('Failed to send email:', error);
    toast.error('Failed to send enquiry');
  }
};


// const [filterInputs, setFilterInputs] = React.useState({
//   location: "",
//   placeId: "",
// });

const handleLocationChange = (selected) => {
  console.log('myselected',selected)
  setFilterInputs({
    location: selected?.label || "",
    placeId: selected?.value || "",
    state: selected?.state || "",
    city: selected?.city || "",
    label: selected?.label || "",
    lat: selected?.lat || "",
    lng: selected?.lng || "",
  });
};

const [isFetchingMore, setIsFetchingMore] = useState(false);

const [lastLoading, setLastLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setlimit] = useState(50);

    
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

    const handleShowMore = () => {
    // Update the skip value to fetch the next set of leads
    setCurrentPage((prevSkip) => prevSkip + limit);
    setLastLoading(true);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const navigate = useNavigate();
  const location = useLocation();


  const initialFilterData = {
  location: "",
  placeId: "",
  Experience: null,
  };

  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  const [filteredCities, setFilteredCities] = useState([]);
 
  
  const [filterInputs, setFilterInputs] = useState(initialFilterData);
  const [doctorList, setDoctorList] = useState([]);
  const [loading, setLoading] = useState(false);

    // Handle change in the search filters
   
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files[0];
    } else {
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setFilterInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }

    setFilterInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };


     
       const handleClearClick = () => {
      
      };
    

 
 

  const searchDoctors = async () => {
    
    if(currentPage === 1){
    setLoading(true);
    }else{
      setIsFetchingMore(true);
    }


       const finalData = {
      state: filterInputs.state || "",
      city: filterInputs.city || "",
      department: filterInputs.department ||  "",
      page:  filterInputs.currentPage || currentPage,
       limit:  filterInputs.limit || limit, 
        lat:  filterInputs.lat || '', 
        lng:  filterInputs.lng || '', 
        Experience:  filterInputs.Experience || '', 
        Distance:  filterInputs.Distance || '', 
        Consultation:  filterInputs.Consultation || '', 
    };
    
 
    try {
    const response = await axiosInstance.get("/all-vendors", {
    params: finalData
  });
  console.log('responseresponseresponseresponseresponse',response.data)
 if (currentPage === 1) {
    setDoctorList(response.data.users);
  } else {
    setDoctorList((prev) => [...prev, ...response.data.users]);
  }
  
  setData2(response.data.allSubDepartments??[]);
  setTotalPages(response.data.totalPages ?? 1);

    } catch (error) {
      // toast.error("Failed to fetch doctors, please try again.");
      console.error(error);
      setDoctorList([]); // Assuming the API returns a list of doctors
    } finally {
      setLoading(false);
      setIsFetchingMore(false);

    }
  };

// 1. Reset page to 1 when filters change
useEffect(() => {
  // Only reset if currentPage is not already 1
  if (currentPage !== 1) {
    setCurrentPage(1);
  } else {
    // If already 1, fetch immediately
    searchDoctors();
  }
}, [
  filterInputs.city,
  filterInputs.Distance,
  filterInputs.Consultation,
  filterInputs.Experience,
  filterInputs.state,
  filterInputs.department,
  filterInputs.lat,
  filterInputs.lng,
  location.search,
]);

// 2. Fetch data when currentPage changes
useEffect(() => {
  // Only fetch if page is changed programmatically
  if (currentPage !== 1) {
    searchDoctors();
  }
}, [currentPage]);


  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  }


  const observer = useRef();

const lastCardRef = useCallback(
  (node) => {
    if (loading || isFetchingMore) return;

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && currentPage < totalPages) {
        setCurrentPage((prev) => prev + 1);
      }
    });

    if (node) observer.current.observe(node);
  },
  [loading, isFetchingMore, currentPage, totalPages]
);

const [myFilter, setFilter] = useState(false);

const toggleFilter = () => {
  setFilter(prev => !prev);
};

  return (
    <>
      <Header hidemob={true} />

      <Helmet>
        <title> All Vendors | {window.location.hostname}</title>
      </Helmet>

{/*  
  <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>State</th>
          <th>City</th>
          <th>Latitude</th>
          <th>Longitude</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{filterInputs.state || 'NA STATE'}</td>
          <td>{filterInputs.city || 'NA city'}</td>
          <td>{filterInputs.lat || 'NA lat'}</td>
          <td>{filterInputs.lng || 'NA lng'}</td>
        </tr>
      </tbody>
    </table> */}

<main className="page">

  <section className="container py-4">

  {/* ✅ TOP FILTER BAR (Latest UI) */}
  <div className="glassbar p-3 mb-4 " style={{top:15}}>
    <div className="row g-3 align-items-center">

      {/* Search */}
      <div className="col-lg-4">
        <div className='d-flex gap-2 align-items-center'>
   <div className="pill-search d-flex align-items-center gap-2 fill w-100">
          <span className="text-muted">🔎</span>
          <input
            className="form-control border-0 bg-transparent p-0 shadow-none"
            placeholder="Search hospital, clinic, city…"
          />
        </div>
        <button className="bg-dark rounded-pill h-100 d-md-none" onClick={toggleFilter} style={{aspectRatio:'1/1'}} >
        
          {myFilter ? 
          <i class="ri-close-line text-white fs-3"/> :
  <i className="ri-filter-3-fill text-white fs-3"/> 
          }
          
        </button> 
        </div>
     
               
      </div>


      {/* City */}
      <div className={`col-lg-3  ${myFilter ? 'd-block': 'd-none d-md-block'}`}>
        <GooglePlaceSelect
  value={
    filterInputs?.placeId
      ? {
          label: filterInputs?.location,
          value: filterInputs?.placeId,
          city: filterInputs?.city,
          state: filterInputs?.state,
          lat: filterInputs?.latitude,
          lng: filterInputs?.longitude,
        }
      : null
  }
  onChange={handleLocationChange}
  CSS="border rounded"
/> 
      </div>

      {/* Specialty */}
      <div className={`col-lg-3  ${myFilter ? 'd-block': 'd-none d-md-block'}`}>
       <Select
  className="border rounded w-100 custom-none-border"
  id="department"
  name="department"
  options={data2.map(item => ({
    label: item,  // Option label (text)
    value: item,   // Option value (ID)
  }))}
  value={data2.find(item => item === filterInputs.department)  // Find the selected state
    ? {
        label: data2.find(item => item === filterInputs.department),  // Display name of the state
        value: data2.find(item => item === filterInputs.department),   // Use the state's ID as value
      }
    : null
  }
  onChange={(selectedOption) => handleChange({
    target: { name: "department", value: selectedOption?.value || "" }
  })}
  isClearable  // Optionally add a clear button
  placeholder={loading ? "Loading..." : "Select Speciality"}  // Change placeholder text to be more relevant
/>

      </div>

      {/* Sort */}
      <div className={`col-lg-2  ${myFilter ? 'd-block': 'd-none d-md-block'}`}>
        <select className="form-select py-2 shadow-none"
         onChange={handleChange}
         name='Distance' value={filterInputs?.Distance} >
           <option value={""}>Select Distance</option>
          <option value={2}>Less than 2 kms</option>
          <option value={5}> Less than 5 kms </option>
          <option value={15} > Less than 15 kms </option>
          <option value={0} >Entire city</option>
        </select>
      </div>
 
      {/* Quick chips */}
      <div className={`col-12  ${myFilter ? 'd-block': 'd-none d-md-block'}`}>
        <div className="d-flex gap-2 flex-wrap">
          <button className="chip active" type="button">All</button>
          <button className="chip" type="button">Open Now</button>
          <button className="chip" type="button">Top Rated</button>
          <button className="chip" type="button">Near Me</button>
          <button className="chip" type="button">24x7</button>
          <button className="chip" type="button">Insurance</button>
        </div>
      </div>

      {/* Result info */}
      <div className="col-12">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div className="small text-muted">
            Showing <b>{doctorList.length ?? 0}</b> Clinics near you
          </div>
            <div className="d-flex gap-2 flex-wrap align-items-center">
          {filterInputs?.city &&   <span className="chip active" type="button" onClick={()=>  
            setFilterInputs((prevData) => ({
      ...prevData, 
     city:null,
    }))} >City: {filterInputs?.city} ✕</span> } 
            {filterInputs?.state &&   <span className="chip active" type="button" onClick={()=>  
            setFilterInputs((prevData) => ({
      ...prevData,
     location: null,
    placeId: null,
    state:  null,
    city:  null,
    label: null,
    lat:  null,
    lng:  null,
    }))
    }>State: {filterInputs?.state} ✕</span> } 
           {filterInputs?.department &&   <span className="chip active" type="button" onClick={()=>  
            setFilterInputs((prevData) => ({
      ...prevData, 
     department:null,
    }))}  >Department: {filterInputs?.department} ✕</span> } 

    {filterInputs?.Distance &&   <span className="chip active" type="button" onClick={()=>  
            setFilterInputs((prevData) => ({
      ...prevData, 
     Distance:"",
    }))}  >Distance: {filterInputs?.Distance}Km ✕</span> } 

            <button className="btn btn-link p-0 text-decoration-none small"  type="button" onClick={()=>  
            setFilterInputs({})
    } >Clear all</button>
          </div>
        </div>
      </div>

    </div>
  </div>


  {/* ✅ HOSPITAL CARDS GRID (6 Cards) */}
  <div className="row g-4">
 
 {loading ? (
              <>
         {Array.from({ length: 4 }).map((_, index) => (
  <div className="col-lg-4 col-md-6" key={index}>
    <div className="doctor-card p-4 h-100">
      
      {/* Header */}
      <div className="d-flex gap-3 align-items-start">
        
        {/* Avatar + Experience */}
        <div className="d-inline-flex flex-column align-items-center gap-2">
          <div
            className="skeleton rounded-circle"
            style={{
              width: "72px",
              height: "72px",
              aspectRatio: "1/1",
            }}
          />
          <div
            className="skeleton rounded-pill"
            style={{ width: "60px", height: "14px" }}
          />
        </div>

        {/* Name + Meta */}
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-center gap-2">
            <div
              className="skeleton rounded"
              style={{ width: "140px", height: "16px" }}
            />
            <div
              className="skeleton rounded"
              style={{ width: "60px", height: "14px" }}
            />
          </div>

          <div
            className="skeleton rounded mt-2"
            style={{ width: "120px", height: "14px" }}
          />

          <div className="d-flex gap-2 mt-3 flex-wrap">
            <div className="skeleton rounded-pill" style={{ width: "50px", height: "22px" }} />
            <div className="skeleton rounded-pill" style={{ width: "80px", height: "22px" }} />
            <div className="skeleton rounded-pill" style={{ width: "90px", height: "22px" }} />
          </div>
        </div>
      </div>

      <div className="soft-divider my-3" />

      {/* Qualification + Languages */}
      <div className="row g-2">
        <div className="col-6">
          <div
            className="skeleton rounded mb-1"
            style={{ width: "80px", height: "14px" }}
          />
          <div
            className="skeleton rounded"
            style={{ width: "100px", height: "14px" }}
          />
        </div>

        <div className="col-6 text-end">
          <div
            className="skeleton rounded mb-1 ms-auto"
            style={{ width: "70px", height: "14px" }}
          />
          <div
            className="skeleton rounded ms-auto"
            style={{ width: "90px", height: "14px" }}
          />
        </div>
      </div>

      {/* Expertise */}
      <div
        className="skeleton rounded mt-3 mb-2"
        style={{ width: "70px", height: "14px" }}
      />

      <div className="d-flex flex-wrap gap-2 mb-4">
        {[1, 2, 3].map((_, i) => (
          <div
            key={i}
            className="skeleton rounded-pill"
            style={{ width: "90px", height: "24px" }}
          />
        ))}
      </div>

      {/* CTA Buttons */}
      <div className="d-flex gap-2">
        <div className="skeleton rounded-pill w-50" style={{ height: "40px" }} />
        <div className="skeleton rounded-pill w-50" style={{ height: "40px" }} />
      </div>

    </div>
  </div>
))}

                
              </>
            ) : (
             !loading && doctorList.length !== 0 ? doctorList.map((doctor,index) => {
                const isLast = index === doctorList.length - 1;
  return ( 
    <>

        <div className="col-lg-4 col-md-6"  key={index} ref={isLast ? lastCardRef : null} >
        <div className="doctor-card p-4 h-100">
   

          {/* Header */}
          <div className="d-flex gap-3 align-items-start">
            <div className='d-inline-flex flex-column align-items-center gap-2'>
  
            <img className="avatar m-0 object-fit-cover d-inline-block" style={{aspectRatio:'1/1',}} src={
                          doctor &&
                          typeof doctor.profile === "string" &&
                          doctor.profile !== ""
                            ? weburl + doctor.profile.replace("public", "")
                            : "/assets/img/placeholder.png"
                        } onError={(e) =>
                          (e.target.src = "/assets/img/placeholder.png")
                        }  alt="doctor" />
             <span className="exp-pill d-inline-block small">{doctor?.experience}</span>
             </div>

                   <div className="flex-grow-1">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <div className="fw-bold" style={{color:"var(--navy)"}}>{doctor.username}</div>
                <span className="verified">✔ Verified</span>
              </div>

              <div className="small text-muted">{doctor?.spec}</div>

              <div className="d-flex align-items-center gap-2 mt-2 flex-wrap">
                <span className="badge bg-primary-subtle text-primary rounded-pill">
                  ★ 4.1
                </span>
                <span className="badge bg-light text-dark border rounded-pill">
                  📍 {doctor?.city}
                </span>
                <span className="badge bg-light text-dark border rounded-pill">
                  Slots Today
                </span>
              </div>
            </div>
          </div>

          <div className="soft-divider my-3" />

          {/* Qualification + Expertise */}
          <div className="row g-2">
            <div className="col-6">
              <div className="small fw-semibold mb-1">Qualification</div>
              <div className="small text-muted">MDS / BDS</div>
            </div>
            <div className="col-6 text-end">
              <div className="small fw-semibold mb-1">Languages</div>
              <div className="small text-muted">Hindi, English</div>
            </div>
          </div>

          <div className="small fw-semibold mt-3 mb-2">Expertise</div>
          <div className="d-flex flex-wrap gap-2 mb-4">
            {doctor?.subDepartments && doctor?.subDepartments.map((s, i) => (
              <span className="skill" key={i}>✓ {s}</span>
            ))}
          </div>

          {/* CTA */}
          <div className="d-flex gap-2">


{!isHeader && (
                                <div className="cat-contact-row mt-0">
                                  <a
                                    href={whatsappHref}
                                    className="btn text-white bg-success w-50 rounded-pill"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <i className="ri-whatsapp-fill" /> WhatsApp
                                  </a>
                                  <Link to={callHref} className="btn btn-primary w-50 rounded-pill">
                                    <i className="ri-phone-line" /> Call Now
                                  </Link>
                                </div>
                              )}




            {/* <Link     to={`/doctor/${doctor._id}`} className="btn btn-outline-primary w-50 rounded-pill">
              View Profile
            </Link>
            <button className="btn btn-primary w-50 rounded-pill">
                             Book Now <i className="ri-arrow-right-line"/>

            </button> */}
          </div>

          <button 
  className="btn btn-primary w-50 rounded-pill mt-2"
  onClick={() => setShowPopup(true)}
>
  Enquire Now
</button>

        </div>
      </div>

   

      
                </>
              )}) : (
              <div className='container d-flex align-items-center justify-content-center' style={{height:'50vh'}}>
                <div className='text-center'>

                <i class="ri-search-eye-line h1 fw-light text-secondary"></i>
                <h3> No users match your search</h3>
                <p> Nothing found for {(() => {
    // Find the selected state once and store it
    const selectedState = data.find(item => item._id === filterInputs.state);
    if (selectedState) {
      return `${selectedState.name} ${filterInputs.city !== null ? `, ${filterInputs.city}` :''} `; // You can format this as you need
    } else {
      return 'India'; // Fallback text if no state is found
    }
  })()}   </p>
                 </div>
                 </div>)
            )}

 

  </div>

 

</section>
  
</main>
            
  
{showPopup && (
  <div className="popup-overlay">
    <div className="popup-box">

      {/* Close Button */}
      <button 
        className="popup-close"
        onClick={() => setShowPopup(false)}
      >
        ✕
      </button>

      <h4 className="mb-3">Send Enquiry</h4>

      <form onSubmit={handleSubmit}>
        
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          className="form-control mb-2"
          value={formData.name}
          onChange={handleFormChange}
          required
        />

        <input
          type="email"
          name="email"
          placeholder="Your Email"
          className="form-control mb-2"
          value={formData.email}
          onChange={handleFormChange}
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="Your Phone"
          className="form-control mb-2"
          value={formData.phone}
          onChange={handleFormChange}
          required
        />

        <textarea
          name="message"
          placeholder="Your Message"
          className="form-control mb-3"
          rows="3"
          value={formData.message}
          onChange={handleFormChange}
        />

        <button type="submit" className="btn btn-dark w-100">
          Submit Enquiry
        </button>

      </form>
    </div>
  </div>
)}

      <Footer />

    </>
  );
};

export default AllVendors;
